import { combineReducers } from 'redux';
import { messenger } from '@breezeway/brzw-react-core';

export default combineReducers({
  autoMessagePropertiesList: messenger.reducers.autoMessagePropertiesList,
  autoMessagePropertiesListSettings: messenger.reducers.autoMessagePropertiesListSettings,
  autoMessagesList: messenger.reducers.autoMessagesList,
  autoMessagesListSettings: messenger.reducers.autoMessagesListSettings,
  taskAutoMessagesList: messenger.reducers.taskAutoMessagesList,
  taskAutoMessagesListSettings: messenger.reducers.taskAutoMessagesListSettings,
  taskAutoMessagesStats: messenger.reducers.taskAutoMessagesStats,
  gapAutoMessagesList: messenger.reducers.gapAutoMessagesList,
  gapAutoMessagesListSettings: messenger.reducers.gapAutoMessagesListSettings,
  gapAutoMessagesStats: messenger.reducers.gapAutoMessagesStats,
  autoMessagesStats: messenger.reducers.autoMessagesStats,
  autoResponsesList: messenger.reducers.autoResponsesList,
  autoResponsesListSettings: messenger.reducers.autoResponsesListSettings,
  contact: messenger.reducers.contact,
  conversation: messenger.reducers.conversation,
  conversations: messenger.reducers.conversations,
  conversationsMessages: messenger.reducers.conversationsMessages,
  messageError: messenger.reducers.messageError,
  reservation: messenger.reducers.reservation,
  bulkMessagesList: messenger.reducers.bulkMessagesList,
  bulkMessagesListSettings: messenger.reducers.bulkeMessagesListSettings,
  bulkMessage: messenger.reducers.bulkMessage,
  bulkMessagesSuccessReportList: messenger.reducers.bulkMessagesSuccessReportList,
  bulkMessagesSuccessReportListSettings: messenger.reducers.bulkMessagesSuccessReportListSettings,
  bulkMessagesFailedReportList: messenger.reducers.bulkMessagesFailedReportList,
  bulkMessagesFailedReportListSettings: messenger.reducers.bulkMessagesFailedReportListSettings,
});
